import { urls } from "../../config/urls";

const securityContent = `<p>At kulpa, the security of our platform and of the evidence entrusted to us is our highest priority. We welcome reports from security researchers, customers and anyone else who believes they have found a security vulnerability in our website, apps, APIs or services.</p>
<h3>How to report</h3>
<p>Please email <a href="mailto:admin@kulpacloud.com?subject=Security%20vulnerability"><strong>admin@kulpacloud.com</strong></a> with "Security vulnerability" in the subject line, or use our <a href="${urls.contactSupport}">Technical Support</a> form and start your message with "Security vulnerability".</p>
<p>To help us investigate, please include:</p>
<p>A description of the vulnerability and its potential impact;</p>
<p>The steps needed to reproduce it;</p>
<p>The affected URL, app version or component;</p>
<p>Any proof of concept, screenshots or logs.</p>
<p>Please do not include any real user data in your report.</p>
<h3>What you can expect from us</h3>
<p>We will acknowledge your report within 5 working days.</p>
<p>We will give you an initial assessment within 10 working days.</p>
<p>We will keep you informed of our progress until the issue is resolved.</p>
<p>With your permission, we are happy to credit you once the issue has been fixed.</p>
<h3>Our guidelines</h3>
<p>When investigating a vulnerability, please:</p>
<p>Act in good faith and avoid accessing, changing or deleting any data that is not your own;</p>
<p>Stop and report to us immediately if you encounter personal data or evidence;</p>
<p>Not carry out denial-of-service testing, social engineering, phishing or physical attacks;</p>
<p>Not use automated scanners in a way that degrades our services;</p>
<p>Give us a reasonable amount of time to fix the issue before disclosing it publicly.</p>
<h3>Our commitment</h3>
<p>We will not take legal action against anyone who reports a vulnerability to us in good faith and in line with these guidelines.</p>
<p><em>kulpa limited is certified to ISO/IEC 27001 and BS 10008.</em></p>`;

export default securityContent;
